class RichText extends HTMLElement {
  constructor() {
    super();

    this.querySelector('.js-toggle-text')?.addEventListener('click', (button) => {
      this.toggleText(button);
    });
  }

  toggleText(button) {
    const shortText = this.querySelector('.short-text');
    const fullText = this.querySelector('.full-text');

    if (fullText.classList.contains('hidden')) {
      shortText.style.display = 'none';
      fullText.classList.remove('hidden');
      button.textContent = 'Show Less';
    } else {
      shortText.style.display = 'block';
      fullText.classList.add('hidden');
      button.textContent = 'Show More';
    }
  }
}
customElements.get('rich-text') || customElements.define('rich-text', RichText);

